module.exports = __webpack_public_path__ + "d7d8a82905c0b04a1dd05f5dd2ff59c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_recency_2x.png
// module id = 127
// module chunks = 0 1 2 3 4